<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script lang="ts" setup>
</script>
<style lang="scss">
@import "@/assets/styles/index.scss";
</style>